import {lumiApi} from "../index";

export const dashboardApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getDashboardList: build.query({
            query: (id) => ({
                url: `projects/${id}/dashboards`,
                method: "GET",
            }),
            providesTags: () => [{ type: "Dashboards" }],
            transformResponse: (response) => response || [],
        }),
        getDashboardDetails: build.query({
            // Adjust according to your API's requirements
            query: ({ projectId, dashboardId }) => ({
                url: `projects/${projectId}/dashboards/${dashboardId}`,
                method: "GET",
            }),
            transformResponse: (response) => response[0]?.charts || [],
        }),
        saveDashboard: build.mutation({
            query: ({ id, dashboard}) => ({
                url: `projects/${id}/dashboards/`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${localStorage.getItem("lumitoken")}`,
                },
                body: JSON.stringify(dashboard),
            }),
            invalidatesTags: ["Dashboards"],
        }),
        updateDashboard: build.mutation({
            query: ({ projectId, dashboardId, data }) => ({
                url: `projects/${projectId}/dashboards/${dashboardId}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${localStorage.getItem("lumitoken")}`,
                },
                body: JSON.stringify({
                    name: data.name,
                    description: data.description,
                    charts: data.charts,
                    top_filters: data.top_filters,
                    selections: data.selections,
                    top_concepts: data.top_concepts,
                    active_concept_list: data.active_concept_list,
                }),
            }),
            invalidatesTags: ["Dashboards"],
        }),
        deleteDashboard: build.mutation({
            query: ({ projectId, dashboardId }) => ({
                url: `projects/${projectId}/dashboards/${dashboardId}`,
                method: "DELETE",
                headers: {
                    Authorization: `Token ${localStorage.getItem("lumitoken")}`,
                },
            }),
            invalidatesTags: ["Dashboards"],
        }),
    }),
});

export const {
    useGetDashboardListQuery,
    useGetDashboardDetailsQuery,
    useSaveDashboardMutation,
    useDeleteDashboardMutation,
    useUpdateDashboardMutation
} = dashboardApi;
